function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { Dropdown } from '@isyc-react/design/overlays';
import { ViewerControlButton } from "../../button";
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../../../i18n/namespaces";
import { RippleButton } from '@isyc-react/form/modules/base/button';
import { ProgressBarIndeterminate } from '@isyc-react/form/modules/base/progress/bar';
import clsx from 'clsx';
import '@isyc-react/design/main';
import "./control-download-overlay.style.scss";
export const ViewerControlDownloadOverlay = props => {
  const {
    progress,
    onCancel
  } = props;
  const [show, setShow] = React.useState(true);
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: false,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'down'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement(ViewerControlButton, _extends({
    disabled: false
  }, toggleProps, {
    onClick: () => meta.toggle(!show),
    className: clsx('position-relative', {
      'control-download-active': show
    })
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-progress-download"
  }), !show && /*#__PURE__*/React.createElement("div", {
    className: "control-download-inactive-pb"
  }, /*#__PURE__*/React.createElement(ProgressBarIndeterminate, {
    style: {
      height: '2px'
    }
  })))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [0, 0]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, menuProps, {
    className: "control-download-overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "control-download-pb-container"
  }, progress ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, progress.percentage, "%"), /*#__PURE__*/React.createElement("div", {
    className: "progress w-100",
    style: {
      height: '3px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar bg-primary",
    role: "progressbar",
    style: {
      width: `${progress.percentage}%`
    }
  })))) : /*#__PURE__*/React.createElement(ProgressBarIndeterminate, {
    style: {
      height: '3px'
    }
  })), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-secondary w-100",
    onClick: () => onCancel()
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-download-off"
  })), /*#__PURE__*/React.createElement("div", null, t('archive.view.controls.downloadCancel')))))));
};